module.exports = __webpack_public_path__ + "assets/img/l3.535a2537.png";